import React, { useState, useEffect } from "react";
import { safeParseJSONString } from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// Component
import ReactJson from 'react-json-view';

// Component styles
import classes from "./JsonWidget.module.scss";

const EMPTY = undefined;

export function JsonWidget(props) {
  const { ui, data, writeBack } = props;
  const widgetId = ui.id;

  const [localContent, setLocalContent] = useState(EMPTY);

  let content = localContent !== EMPTY ? localContent : data && data.content ? safeParseJSONString(data.content) : null;
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    console.log("JsonWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const onChanging = (args) => {
    //console.log("JsonWidget onChanging", args);
    var value = args.updated_src;
    var valueStr = JSON.stringify(value, null, 2);
    setLocalContent(value);
    writeBack(valueStr, true);
  };

  return (
    <div className={cn(classes.editorContainer, "dx-theme-border-color")}>
      {content
        ? (
          <ReactJson
            id={widgetId}
            name={null}
            iconStyle="triangle"
            enableClipboard={false}
            quotesOnKeys={false}
            displayDataTypes={true}
            displayObjectSize={false}
            src={content}
            onEdit={disabled ? false : (e) =>  onChanging(e)}
            onAdd={disabled ? false : (e) => onChanging(e)}
            onDelete={disabled ? false : (e) => onChanging(e)}
          />
        )
        : null
      }
    </div>
  );
}